import { OtherUserPreferences } from '@models/other-user-preferences';
import { ClassCast } from '@utilities/object-helper';
export class UserPreferences {
  showMinisidebar: boolean;
  theme: string;
  @ClassCast(OtherUserPreferences)
  otherPrefs: OtherUserPreferences;
}
